<div class='payment-method-main' data-cy="payment-method-container">
  <mat-progress-spinner *ngIf="false" style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate" data-cy="payment-method-loading-spinner"></mat-progress-spinner>
  <mat-grid-list cols="6" rowHeight="100%" style="height:100%;" data-cy="payment-method-grid">
    <mat-grid-tile colspan="2" data-cy="payment-method-list-tile">
      <mat-card appearance="outlined" style="width:100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="payment-method-list-card">
        <span class="configuration-section-title" data-cy="payment-method-list-title">Payment Methods</span>
        <div style="flex: 1; max-height: 100%; overflow-y: hidden;" data-cy="payment-method-list-content">

          <mat-form-field style="width:100%; margin-top: 3px;" data-cy="payment-method-client-field">
            <mat-label data-cy="payment-method-client-label">Practice (Licensee)</mat-label>
            <mat-select [(value)]="selectedClient" (selectionChange)="onChangeClient($event)" data-cy="payment-method-client-select">
              <mat-option *ngFor="let client of clientList" [value]="client" data-cy="payment-method-client-option">
                {{client.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width:100%" data-cy="payment-method-location-field">
            <mat-label data-cy="payment-method-location-label">Practice Locations</mat-label>
            <mat-select [(value)]="selectedLocation" (selectionChange)="onChangeLoc('')" data-cy="payment-method-location-select">
              <mat-option *ngFor="let loc of locationList" [value]="loc" data-cy="payment-method-location-option">
                {{loc.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="locationList.length > 0" data-cy="payment-method-table-container">

            <tdo-table [dataSource]="this.paymentMethods"
                       [isMultiSelection]="false" [isSearchable]="false" [isUsePaginator]="false"
                       (rowSelected)="onRowSelected($event)"
                       data-cy="payment-method-table">
              <tdo-table-column displayName="Name" propertyName="Name" isSortable="true" [rowTemplate]="name" data-cy="payment-method-name-column">
                <ng-template #name let-row>
                  <div *ngIf="row.Name" data-cy="payment-method-name-value">{{ row.Name }}</div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Description" propertyName="Description" isSortable="true" [rowTemplate]="desc" data-cy="payment-method-description-column">
                <ng-template #desc let-row>
                  <div *ngIf="row.Description" data-cy="payment-method-description-value">{{ row.Description }}</div>
                </ng-template>
              </tdo-table-column>
            </tdo-table>

          </div>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" data-cy="payment-method-detail-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="payment-method-detail-card">
        <mat-card-content data-cy="payment-method-detail-content">
          <div style="max-width: 700px;" data-cy="payment-method-form-container">
            <span class="configuration-section-title" data-cy="payment-method-detail-title">Payment Method Information</span>
            <app-tdo-configuration-action-bar
              #actionBar
              *ngIf="(this.locationList.length > 0)"
              [showEdit]="(!isEditing && this.selectedPaymentMethod != null)"
              (editClick)="onEdit($event)"
              [saveDisabled]="saveDisabled || (selectedPaymentMethod ? (selectedPaymentMethod.Name ? selectedPaymentMethod.Name : '') : '').trim() === '' || !selectedPaymentMethod.LOCID"
              [showSave]="!saveDisabled"
              [showCancel]="!saveDisabled"
              [showClear]="false"
              (saveClick)="onSave($event)"
              (cancelClick)="onCancel($event)"
              (newClick)="onNewPaymentMethod($event)"
              (clearClick)="onClearPaymentMethods()"
              [showAdd]="false"
              [newHidden]="false"
              data-cy="payment-method-action-bar">
            </app-tdo-configuration-action-bar>

            <div *ngIf="this.selectedPaymentMethod" style="display:flex; flex-direction: column; height: 775px" data-cy="payment-method-form">

              <div style="flex: 1; overflow: auto" data-cy="payment-method-form-fields">
                <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="payment-method-name-field">
                  <mat-label data-cy="payment-method-name-label">Name</mat-label>
                  <input matInput [(ngModel)]="this.selectedPaymentMethod.Name" [disabled]="!this.isEditing" data-cy="payment-method-name-input">
                </mat-form-field>

                <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="payment-method-description-field">
                  <mat-label data-cy="payment-method-description-label">Description</mat-label>
                  <input matInput [(ngModel)]="this.selectedPaymentMethod.Description" [disabled]="!this.isEditing" data-cy="payment-method-description-input">
                </mat-form-field>


                <div data-cy="payment-method-type-container">
                  <mat-form-field style="float: left; width: 70%" data-cy="payment-method-type-field">
                    <mat-label data-cy="payment-method-type-label">Type</mat-label>
                    <mat-select [(value)]="selectedPaymentMethod.enumARPayementTypeID" [disabled]="!this.isEditing" data-cy="payment-method-type-select">
                      <mat-option *ngFor="let type of this.paymentTypes" [value]="type.ValidValueItemId" data-cy="payment-method-type-option">
                        {{ type.ItemDisplayValue }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button mat-raised-button color="primary" style="float: right" [disabled]="!this.isEditing" (click)="onClickClearType()" data-cy="payment-method-clear-type-button">Clear</button>
                </div>

                <div data-cy="payment-method-electronic-container">
                  <mat-form-field style="float: left; width: 70%" data-cy="payment-method-electronic-field">
                    <mat-label data-cy="payment-method-electronic-label">Electronic</mat-label>
                    <mat-select [(value)]="selectedPaymentMethod.enumARPayementETypeID" [disabled]="!this.isEditing" data-cy="payment-method-electronic-select">
                      <mat-option *ngFor="let type of this.paymentESources" [value]="type.ValidValueItemId" data-cy="payment-method-electronic-option">
                        {{ type.ItemDisplayValue }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button mat-raised-button color="primary" style="float: right" [disabled]="!this.isEditing" (click)="onClickClearEType()" data-cy="payment-method-clear-electronic-button">Clear</button>
                </div>

                <div data-cy="payment-method-cctype-container">
                  <mat-form-field style="float: left; width: 70%" data-cy="payment-method-cctype-field">
                    <mat-label data-cy="payment-method-cctype-label">CC Type</mat-label>
                    <mat-select [(value)]="selectedPaymentMethod.enumARPayementCCTypeID" [disabled]="!this.isEditing" data-cy="payment-method-cctype-select">
                      <mat-option *ngFor="let type of this.paymentCCSources" [value]="type.ValidValueItemId" data-cy="payment-method-cctype-option">
                        {{ type.ItemDisplayValue }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button mat-raised-button color="primary" style="float: right" [disabled]="!this.isEditing" (click)="onClickClearCCType()" data-cy="payment-method-clear-cctype-button">Clear</button>
                </div>

                <div data-cy="payment-method-account-container">
                  <mat-form-field style="float: left; width: 70%" data-cy="payment-method-account-field">
                    <mat-label data-cy="payment-method-account-label">Default Deposit Account</mat-label>
                    <mat-select [(value)]="selectedPaymentMethod.ARAccountID" [disabled]="!this.isEditing" data-cy="payment-method-account-select">
                      <mat-option *ngFor="let acct of this.listOfAccounts" [value]="acct.ARAccountID" data-cy="payment-method-account-option">
                        {{ acct.AccountName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button mat-raised-button color="primary" style="float: right" [disabled]="!this.isEditing" (click)="onClickClearARAcc()" data-cy="payment-method-clear-account-button">Clear</button>
                </div>
                <div style="float: left; width: 70%" data-cy="payment-method-active-container">
                <!-- active -->
                <mat-checkbox [(ngModel)]="selectedPaymentMethod.isActive" [disabled]="!this.isEditing" data-cy="payment-method-active-checkbox">Is Active</mat-checkbox>
                </div>
              </div>

            </div>
            <div *ngIf="this.isLoading" data-cy="payment-method-detail-loading">
              <mat-spinner style="margin-left: auto; margin-right: auto;" data-cy="payment-method-detail-spinner"></mat-spinner>
            </div>

          </div>

        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>


